var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitAndLoss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.314 59.728 5.353-5.353a1.164 1.164 0 0 0-.814-1.978h-3.026v-5.818a1.047 1.047 0 0 0-1.163-1.164h-2.328a1.047 1.047 0 0 0-1.163 1.164v5.818h-3.026a1.164 1.164 0 0 0-.814 1.978l5.352 5.353a1.164 1.164 0 0 0 1.63 0ZM50.685 22.333l-5.352 5.352a1.163 1.163 0 0 0 .814 1.979h3.026v5.818a1.047 1.047 0 0 0 1.163 1.163h2.328a1.047 1.047 0 0 0 1.163-1.163v-5.819h3.026a1.164 1.164 0 0 0 .814-1.978l-5.352-5.352a1.164 1.164 0 0 0-1.63 0Z",
    fill: "#A0C9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.833 30c0 5.983-4.85 10.833-10.833 10.833-5.983 0-10.833-4.85-10.833-10.833 0-5.983 4.85-10.833 10.833-10.833 5.983 0 10.833 4.85 10.833 10.833Z",
    fill: "#006C52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.917 22.417a1.083 1.083 0 0 1 2.166 0V23.5a3.25 3.25 0 0 1 3.25 3.25 1.083 1.083 0 1 1-2.166 0c0-.598-.485-1.083-1.084-1.083h-2.166c-.599 0-1.084.485-1.084 1.083v.605c0 .466.299.88.741 1.028l3.537 1.179a3.25 3.25 0 0 1 2.222 3.083v.605a3.25 3.25 0 0 1-3.25 3.25v1.083a1.083 1.083 0 1 1-2.166 0V36.5a3.25 3.25 0 0 1-3.25-3.25 1.083 1.083 0 0 1 2.166 0c0 .598.485 1.083 1.084 1.083h2.166c.599 0 1.084-.485 1.084-1.083v-.605c0-.466-.299-.88-.741-1.028l-3.537-1.179a3.25 3.25 0 0 1-2.222-3.083v-.605a3.25 3.25 0 0 1 3.25-3.25v-1.083Z",
    fill: "#A0C9BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.833 50c0 5.983-4.85 10.833-10.833 10.833-5.983 0-10.833-4.85-10.833-10.833 0-5.983 4.85-10.833 10.833-10.833 5.983 0 10.833 4.85 10.833 10.833Z",
    fill: "#006C52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.917 42.417a1.083 1.083 0 0 1 2.166 0V43.5a3.25 3.25 0 0 1 3.25 3.25 1.083 1.083 0 1 1-2.166 0c0-.598-.485-1.083-1.084-1.083h-2.166c-.599 0-1.084.485-1.084 1.083v.605c0 .466.299.88.741 1.028l3.537 1.179a3.25 3.25 0 0 1 2.222 3.083v.605a3.25 3.25 0 0 1-3.25 3.25v1.083a1.083 1.083 0 1 1-2.166 0V56.5a3.25 3.25 0 0 1-3.25-3.25 1.083 1.083 0 0 1 2.166 0c0 .598.485 1.083 1.084 1.083h2.166c.599 0 1.084-.485 1.084-1.083v-.605c0-.466-.299-.88-.741-1.028l-3.537-1.179a3.25 3.25 0 0 1-2.222-3.083v-.605a3.25 3.25 0 0 1 3.25-3.25v-1.083Z",
    fill: "#A0C9BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitAndLoss);
export default __webpack_public_path__ + "static/media/profit-and-loss.5b29a766.svg";
export { ForwardRef as ReactComponent };